import { KbSearchBase } from "./kb-search-base";
import { html } from "lit-html";
import { storeInstance } from "store/index.js";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import { Router } from "@vaadin/router/dist/vaadin-router.js";
import KbParser from "../utils/KbParser";
import { itemTypes } from "../lib/constants";

class KbPubSearch2 extends KbSearchBase {
  static get properties() {
    return {
      searchResults: { type: Array },
    };
  }

  constructor() {
    super();
    this.hasPaging = false;
  }

  getDataFromStore() {
    super.getDataFromStore();
    this.searchResults = this.state.pub_search_results;
  }

  pageName = "pubsearch";

  getResults() {
    storeInstance.dispatch("getPanelPubSearchResults");
  }

  /*--- Pubsearch Specific ---*/
  async handleLinkClick(publication) {
    if (publication.kbResId) {
      await this._gotoItem(publication.kbResId);
    } else {
      Router.go("/kb/" + this.state.langCode + "/" + publication.itemExtId);
    }
  }

  async _gotoItem(kbResId) {
    this.parser = new KbParser();
    this.parser.setHref(kbResId);
    let newLink = await this.parser.parse();
    Router.go(newLink);
  }

  iconTemplate(iconName, type) {
    return html`<span class=${`badge badge-${type}`}
      >${type} <iron-icon icon=${`${iconName}`}></iron-icon
    ></span>`;
  }

  shortcutIconTemplate(kbResId) {
    let publicationType = kbResId?.split("~")[0];
    console.log(publicationType);
    if (publicationType === "SC")
      return html`<iron-icon
        class="shortcut-icon"
        icon="vaadin:arrow-forward"
      ></iron-icon>`;
  }

  publicationIconTemplate(type) {
    switch (type) {
      case itemTypes.filepub:
        return this.iconTemplate("vaadin:file-text", "File");
      case itemTypes.download:
        return this.iconTemplate("vaadin:download", "Download");
      case itemTypes.helpset:
        return this.iconTemplate("vaadin:file-tree-sub", "Helpset");
      case itemTypes.dhs:
        return this.iconTemplate("vaadin:file-tree-sub", "Helpset");
    }
  }

  /*--- Templates ---*/
  headerTemplate() {
    return html` <h1 class="results-caption">Browse Publications</h1> `;
  }

  resultsTemplate() {
    return html`
      <ul style="margin: 0; padding: 0">
        ${this.searchResults.length < 1
          ? html`<p>No publications found</p>`
          : null}
        ${this.searchResults.map(
          (publication) =>
            html`<li
              class="result"
              @click=${async () => await this.handleLinkClick(publication)}
            >
              <a class="result-content" data-href=${publication.kbResId}>
                <div>
                  <h3 class="result__name">${publication.name}</h3>
                  <p class="result__description">${publication.description}</p>
                </div>
                <div class="result__details-container">
                  ${this.shortcutIconTemplate(publication.kbResId)}
                  ${this.publicationIconTemplate(publication.itemType)}
                </div>
                <!-- <span>${publication.lastModDate}</span> -->
              </a>
            </li>`
        )}
      </ul>
    `;
  }
}

customElements.define("kb-pubsearch2", KbPubSearch2);
